import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from "react-bootstrap";
import { getDocketGeneralInfo, viewPartyInfo } from '../../../../actions/docketGeneralInfoAction';
import {mediaPath } from "../../../../config";

class DocketParties extends Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			showModal: false,
			hideShow: false,
			altaddress: false,
			badgeNo: false,
		};
	}

	handleShow() {
			this.setState({ showModal: true });
	}
	hideShowPartyFields(tablename, contactType) {
		this.setState({ altaddress: false });
		this.setState({ hideShow: false });
		if (!tablename && contactType === 'Minor/Children') {
			this.setState({ hideShow: '2' });
		}
		if (tablename === 'attorneybycase') {
			this.setState({ hideShow: '3' });
		}
		if (contactType === 'Petitioner' || contactType === 'Respondent') {
			this.setState({ altaddress: true });
		}
		if (contactType === 'Officer') {
			this.setState({ badgeNo: true });
		}
	}
	handleClose() {
		this.setState({ showModal: false });
	}
	allParties = () => {
		if (this.props.docketGeneralInfo.Parties !== undefined && this.props.docketGeneralInfo.Parties.length > 0) {

			return this.props.docketGeneralInfo.Parties.map((value, k) => {
				return <div className="col-xs-6" key={k}>
					<div className="party-block">
						<div className="heading">
							<span>{value.typeofcontact ? value.typeofcontact : 'Minor/Children'}</span>
							<span>
								<a aria-label="View more" href="javascript:;" onClick={() => { this.props.viewPartyInfo({ contact_type: value.typeofcontact, peopleId: value.peopleid, MinorId: value.Minorid, sNo: value.sno }); this.handleShow(); this.hideShowPartyFields(value.tablename, value.typeofcontact ? value.typeofcontact : 'Minor/Children'); }}>View more</a>
							</span>
						</div>
						<div className="party-body">
							<div>
							<p>{value.Lastname}, {value.Firstname}</p>
							{value.typeofcontact ? 
								<p>
									<label><i className="fa fa-phone" aria-hidden="true"></i> Phone: </label>
								<span>{value.Phone != '' ? value.Phone : '-'}</span>
							</p>:''}
							{value.typeofcontact ? 
								<p>
									<label><i className="fa fa-envelope-o" aria-hidden="true"></i> Email: </label>
								<span>{value.Email != '' && value.Email != 'No Email' ? value.Email : '-'}</span>
								</p>:''}
							{value.typeofcontact ? 	
								<p>
									<label><i className="fa fa-fax" aria-hidden="true"></i> Fax: </label>
								<span>{value.Fax != '' && value.Fax != null ? value.Fax : value.fax != '' && value.fax != null ? value.fax : '-'}</span>
								</p>:''}
						</div>
						<div className="optedtooltip-block">
							{value.typeofcontact ? value.e_services==='1' ? <div><div class="optedin"><i class="fa fa-check-circle" aria-hidden="true"></i> <span>Opted-In</span></div><span className="tooltiptext" >This user may be served electronically via ePortal.</span></div> : 
							<div><div class="optedout"><i class="fa fa-pause" aria-hidden="true"></i> <span>Opted-Out</span>
							</div><span className="tooltiptext" >This user may not be served via ePortal. They must be served by first class mail, email, or personal delivery.</span></div> : ''}
						</div>
						</div>
					</div>
				</div>
			})
		}
	}

	render() {
		const viewPartiesInfo = this.props.docketGeneralInfo.partyInfo || [];

		return (
			<div>
				<div className="party-info-block">
					<h2>Parties</h2>
					<div>
						{this.allParties()}
					</div>
				</div>
				<Modal show={this.state.showModal}
					onHide={() => this.handleClose()}
					backdrop="static" id="view-more"
					className="modal fade">
					<Modal.Header>
						<button type="button" className="close" onClick={() => this.handleClose()} aria-label="Close modal"><img src={mediaPath+"close.png"} alt="close" /></button>
						<h4 className="modal-title">View Party</h4>
					</Modal.Header>
					<Modal.Body>
						<div className="row">
							<div className="col-xs-4">
								<label>Contact Type</label>
								<span>{viewPartiesInfo.typeofcontact ? viewPartiesInfo.typeofcontact : 'Minor/Children'}</span>
							</div>
						</div>
						<div className="row">
							<div className="col-xs-4">
								<label>Last Name</label>
								<span>{viewPartiesInfo.Lastname}</span>
							</div>
							<div className="col-xs-4">
								<label>First Name</label>
								<span>{viewPartiesInfo.Firstname}</span>
							</div>
							<div className="col-xs-4">
								<label>Middle Name</label>
								<span>{viewPartiesInfo.Middlename != '' && viewPartiesInfo.Middlename != null ? viewPartiesInfo.Middlename : '-'}</span>
							</div>
						</div>
						{this.state.hideShow == '2' ? <div className="row">
							<div className="col-xs-4">
								<label>Year of Birth</label>
								<span>{viewPartiesInfo.dobyear != '' && viewPartiesInfo.dobyear != null ? viewPartiesInfo.dobyear : '-'}</span>
							</div>
						</div> : <div></div>}
						{this.state.hideShow == '3' ? <div className="row">
							<div className="col-xs-4">
								<label>Attorney Bar #</label>
								<span>{viewPartiesInfo.AttorneyBar != '' && viewPartiesInfo.AttorneyBar != null ? viewPartiesInfo.AttorneyBar : '-'}</span>
							</div>
						</div> : <div></div>}
						{this.state.badgeNo ? <div className="row">
							<div className="col-xs-4">
								<label>Badge #</label>
								<span>{viewPartiesInfo.badge_no != '' && viewPartiesInfo.badge_no != null ? viewPartiesInfo.badge_no : '-'}</span>
							</div>
						</div> : <div></div>}
						{this.state.hideShow != '2' ? <div className="row">
							<div className="col-xs-4">
								<label>Title</label>
								<span>{viewPartiesInfo.Title != '' && viewPartiesInfo.Title != null ? viewPartiesInfo.Title : '-'}</span>
							</div>
							<div className="col-xs-4">
								<label>Company Name</label>
								<span>{viewPartiesInfo.Company != '' && viewPartiesInfo.Company != null ? viewPartiesInfo.Company : '-'}</span>
							</div>
						</div> : <div></div>}
						{(viewPartiesInfo.is_international_addr=='1')?<div className="row">
						<div className="col-xs-12"><label>International Address</label>
						<span>{viewPartiesInfo.international_address}</span>
						</div></div>:''}
						
						{(viewPartiesInfo.is_international_addr=='0') ? this.state.hideShow != '2' ? <div className="row">
							<div className="col-xs-12">
								<label>Address Line 1</label>
								<span>{viewPartiesInfo.Address1}</span>
							</div>
						</div> : <div></div> 
						:""
						}
						{(viewPartiesInfo.is_international_addr=='0') ? this.state.hideShow != '2' ? <div className="row">
							<div className="col-xs-12">
								<label>Address Line 2</label>
								<span>{viewPartiesInfo.Address2 != '' && viewPartiesInfo.Address2 != null ? viewPartiesInfo.Address2 : '-'}</span>
							</div>
						</div> : <div></div>
						:""}
						{(viewPartiesInfo.is_international_addr=='0') ? this.state.hideShow != '2' ? <div className="row">
							<div className="col-xs-4">
								<label>City</label>
								<span>{viewPartiesInfo.City}</span>
							</div>
							<div className="col-xs-4">
								<label>State</label>
								<span>{viewPartiesInfo.State}</span>
							</div>
							<div className="col-xs-4">
								<label>Zip Code</label>
								<span>{viewPartiesInfo.Zip}</span>
							</div>
						</div> : <div></div>
						:''}
						{(viewPartiesInfo.is_international_addr=='0') ? this.state.hideShow != '2' && this.state.altaddress ? <div className="row">
							<div className="col-xs-12">
								<label>Second Address Line 1</label>
								<span>{viewPartiesInfo.alt_address1 != '' && viewPartiesInfo.alt_address1 != null ? viewPartiesInfo.alt_address1 : '-'}</span>
							</div>
						</div> : <div></div>
						:''}
						{(viewPartiesInfo.is_international_addr=='0') ? this.state.hideShow != '2' && this.state.altaddress ? <div className="row">
							<div className="col-xs-12">
								<label>Second Address Line 2</label>
								<span>{viewPartiesInfo.alt_address2 != '' && viewPartiesInfo.alt_address2 != null ? viewPartiesInfo.alt_address2 : '-'}</span>
							</div>
						</div> : <div></div>
						:''}
						{(viewPartiesInfo.is_international_addr=='0') ? this.state.hideShow != '2' && this.state.altaddress ? <div className="row">
							<div className="col-xs-4">
								<label>Second City</label>
								<span>{viewPartiesInfo.alt_city != '' && viewPartiesInfo.alt_city != null ? viewPartiesInfo.alt_city : '-'}</span>
							</div>
							<div className="col-xs-4">
								<label>Second State</label>
								<span>{viewPartiesInfo.alt_state != '' && viewPartiesInfo.alt_state != null ? viewPartiesInfo.alt_state : '-'}</span>
							</div>
							<div className="col-xs-4">
								<label>Second Zip Code</label>
								<span>{viewPartiesInfo.alt_zip_code != '' && viewPartiesInfo.alt_zip_code != null ? viewPartiesInfo.alt_zip_code : '-'}</span>
							</div>
						</div> : <div></div>
						:''}
						{this.state.hideShow != '2' ? <div className="row">
							<div className="col-xs-4">
								<label>Phone</label>
								<span>{viewPartiesInfo.Phone!='' && viewPartiesInfo.Phone!=null ? viewPartiesInfo.Phone : '-'}</span>
							</div>
							<div className="col-xs-4">
								<label>Email</label>
								<span>{viewPartiesInfo.Email}</span>
							</div>
							<div className="col-xs-4">
								<label>Fax</label>
								<span>{viewPartiesInfo.Fax != '' && viewPartiesInfo.Fax != null ? viewPartiesInfo.Fax : viewPartiesInfo.fax != '' && viewPartiesInfo.fax != null ? viewPartiesInfo.fax : '-'}</span>
							</div>
						</div> : <div></div>}
					</Modal.Body>
					<Modal.Footer>
						<div className="btn-block">
							<button type="button" aria-label="Close modal" className="btn cancel" onClick={() => this.handleClose()}>Close</button>
						</div>
					</Modal.Footer>
				</Modal>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		docketGeneralInfo: state.docketGeneralInfo,
	};
}

export default connect(mapStateToProps, { getDocketGeneralInfo, viewPartyInfo })(DocketParties);